// @ts-nocheck
import React from 'react';
import Sharings from 'components/access/Sharings';

const PenlyAccessSharings = () => (
    <Sharings />
);

export default PenlyAccessSharings;
